import { render, staticRenderFns } from "./cuccLog.vue?vue&type=template&id=48684754&scoped=true&"
import script from "./cuccLog.vue?vue&type=script&lang=js&"
export * from "./cuccLog.vue?vue&type=script&lang=js&"
import style0 from "./cuccLog.vue?vue&type=style&index=0&id=48684754&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48684754",
  null
  
)

export default component.exports